import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import Parser from 'html-react-parser';

const Page = (Props) =>{
    console.log(Props);
    return(
        <div className={`common-bg pages ${Props.data.extra_class}-top ${Props.data.show_header_title?Props.data.title:""}`}>
            <div className="container">
            {Props.data.show_header?<Header title={Props.data.show_header_title?Props.data.title:""} type="Primary"/>:""}
                <div className="content-wrap bg-gradient-light">
                    <div className={Props.data.extra_class}>
                        {Props.data.featured_image.data?<img src={Props.data.featured_image.data.attributes.url} alt="featured-img"/> :""}
                        {Parser(Props.data.content)}
                    </div>
                </div> 
            <Footer />   
            </div>
        </div>
    );
}
export default Page;